// extracted by mini-css-extract-plugin
module.exports = {"PXPResult":"PXPResult_PXPResult__x79Bq"};